export const questionsCategoryC: Record<string, PolicyFormQuestion> = {
  medicalPhysicalTherapyFirstInsured: {
    id: 'medical-physical-therapy-first-insured',
    questionRef: 'medicalPhysicalTherapyFirstInsured',
    title: 'Is the proposed insured currently receiving physical therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOccupationalTherapyFirstInsured: {
    id: 'medical-occupational-therapy-first-insured',
    questionRef: 'medicalOccupationalTherapyFirstInsured',
    title: 'Is the proposed insured currently receiving occupational therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSpeechTherapyFirstInsured: {
    id: 'medical-speech-therapy-first-insured',
    questionRef: 'medicalSpeechTherapyFirstInsured',
    title: 'Is the proposed insured currently receiving speech therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalRespiratoryTherapyFirstInsured: {
    id: 'medical-respiratory-therapy-first-insured',
    questionRef: 'medicalRespiratoryTherapyFirstInsured',
    title: 'Is the proposed insured currently receiving respiratory therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCaneUseFirstInsured: {
    id: 'medical-cane-use-first-insured',
    questionRef: 'medicalCaneUseFirstInsured',
    title: 'Is the proposed insured currently using a cane?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCrutchUseFirstInsured: {
    id: 'medical-crutch-use-first-insured',
    questionRef: 'medicalCrutchUseFirstInsured',
    title: 'Is the proposed insured currently using a crutch?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalWalkerUseFirstInsured: {
    id: 'medical-walker-use-first-insured',
    questionRef: 'medicalWalkerUseFirstInsured',
    title: 'Is the proposed insured currently using a walker?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalWheelchairUseFirstInsured: {
    id: 'medical-wheelchair-use-first-insured',
    questionRef: 'medicalWheelchairUseFirstInsured',
    title: 'Is the proposed insured currently using a wheelchair?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMotorizedScooterUseFirstInsured: {
    id: 'medical-motorized-scooter-use-first-insured',
    questionRef: 'medicalMotorizedScooterUseFirstInsured',
    title: 'Is the proposed insured currently using a motorized scooter?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMotorizedChairUseFirstInsured: {
    id: 'medical-motorized-chair-use-first-insured',
    questionRef: 'medicalMotorizedChairUseFirstInsured',
    title: 'Is the proposed insured currently using a motorized chair?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalStairLiftUseFirstInsured: {
    id: 'medical-stair-lift-use-first-insured',
    questionRef: 'medicalStairLiftUseFirstInsured',
    title: 'Is the proposed insured currently using a stair lift?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHandicappedPlacardUseFirstInsured: {
    id: 'medical-handicapped-placard-use-first-insured',
    questionRef: 'medicalHandicappedPlacardUseFirstInsured',
    title: 'Is the proposed insured currently using a handicapped parking plate/placard/sticker?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCatheterUseFirstInsured: {
    id: 'medical-catheter-use-first-insured',
    questionRef: 'medicalCatheterUseFirstInsured',
    title: 'Is the proposed insured currently using a catheter?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOxygenEquipmentUseFirstInsured: {
    id: 'medical-oxygen-equipment-use-first-insured',
    questionRef: 'medicalOxygenEquipmentUseFirstInsured',
    title: 'Is the proposed insured currently using oxygen equipment?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalRespiratorUseFirstInsured: {
    id: 'medical-respirator-use-first-insured',
    questionRef: 'medicalRespiratorUseFirstInsured',
    title: 'Is the proposed insured currently using a respirator?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCpapUseFirstInsured: {
    id: 'medical-cpap-use-first-insured',
    questionRef: 'medicalCpapUseFirstInsured',
    title: 'Is the proposed insured currently using CPAP or Bi-PAP?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDefibrillatorUseFirstInsured: {
    id: 'medical-defibrillator-use-first-insured',
    questionRef: 'medicalDefibrillatorUseFirstInsured',
    title: 'Is the proposed insured currently using a defibrillator?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPacemakerUseFirstInsured: {
    id: 'medical-pacemaker-use-first-insured',
    questionRef: 'medicalPacemakerUseFirstInsured',
    title: 'Is the proposed insured currently using a pacemaker?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDialysisUseFirstInsured: {
    id: 'medical-dialysis-use-first-insured',
    questionRef: 'medicalDialysisUseFirstInsured',
    title: 'Is the proposed insured currently using a dialysis machine?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUpcomingVisitFirstInsured: {
    id: 'medical-upcoming-visit-first-insured',
    questionRef: 'medicalUpcomingVisitFirstInsured',
    title: 'Does the proposed insured have an upcoming visit with a health care professional?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCurrentlyPregnantFirstInsured: {
    id: 'medical-currently-pregnant-first-insured',
    questionRef: 'medicalCurrentlyPregnantFirstInsured',
    title: 'Is the proposed insured currently pregnant?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPrimaryCarePhysicianFirstInsuredName: {
    id: 'medical-primary-care-physician-first-insured-name',
    questionRef: 'medicalPrimaryCarePhysicianFirstInsuredName',
    title:
      'List the name of the primary care physician for the Proposed Insured',
    type: 'text',
    required: true,
  },
  medicalPrimaryCarePhysicianFirstInsuredAddress: {
    id: 'medical-primary-care-physician-first-insured-address',
    questionRef: 'medicalPrimaryCarePhysicianFirstInsuredAddress',
    title:
      'List address of current or most recent primary care physician for the Proposed Insured',
    type: 'text',
    required: true,
    validationType: 'address',
  },

  medicalMedicationsFirstInsured: {
    id: 'medical-medications-first-insured',
    questionRef: 'medicalMedicationsFirstInsured',
    title: 'List all medications currently being taken.',
    type: 'table',
    required: true,
    minRows: 0,
    maxRows: 3,
    columns: [
      {
        id: 'medicalMedicationsItem',
        title: 'Medication',
        type: 'text',
        required: true,
      },
    ],
  },

  medicalPhysicalTherapySecondInsured: {
    id: 'medical-physical-therapy-second-insured',
    questionRef: 'medicalPhysicalTherapySecondInsured',
    title: 'Is the proposed insured currently receiving physical therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOccupationalTherapySecondInsured: {
    id: 'medical-occupational-therapy-second-insured',
    questionRef: 'medicalOccupationalTherapySecondInsured',
    title: 'Is the proposed insured currently receiving occupational therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalSpeechTherapySecondInsured: {
    id: 'medical-speech-therapy-second-insured',
    questionRef: 'medicalSpeechTherapySecondInsured',
    title: 'Is the proposed insured currently receiving speech therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalRespiratoryTherapySecondInsured: {
    id: 'medical-respiratory-therapy-second-insured',
    questionRef: 'medicalRespiratoryTherapySecondInsured',
    title: 'Is the proposed insured currently receiving respiratory therapy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCaneUseSecondInsured: {
    id: 'medical-cane-use-second-insured',
    questionRef: 'medicalCaneUseSecondInsured',
    title: 'Is the proposed insured currently using a cane?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCrutchUseSecondInsured: {
    id: 'medical-crutch-use-second-insured',
    questionRef: 'medicalCrutchUseSecondInsured',
    title: 'Is the proposed insured currently using a crutch?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalWalkerUseSecondInsured: {
    id: 'medical-walker-use-second-insured',
    questionRef: 'medicalWalkerUseSecondInsured',
    title: 'Is the proposed insured currently using a walker?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalWheelchairUseSecondInsured: {
    id: 'medical-wheelchair-use-second-insured',
    questionRef: 'medicalWheelchairUseSecondInsured',
    title: 'Is the proposed insured currently using a wheelchair?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMotorizedScooterUseSecondInsured: {
    id: 'medical-motorized-scooter-use-second-insured',
    questionRef: 'medicalMotorizedScooterUseSecondInsured',
    title: 'Is the proposed insured currently using a motorized scooter?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalMotorizedChairUseSecondInsured: {
    id: 'medical-motorized-chair-use-second-insured',
    questionRef: 'medicalMotorizedChairUseSecondInsured',
    title: 'Is the proposed insured currently using a motorized chair?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalStairLiftUseSecondInsured: {
    id: 'medical-stair-lift-use-second-insured',
    questionRef: 'medicalStairLiftUseSecondInsured',
    title: 'Is the proposed insured currently using a stair lift?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalHandicappedPlacardUseSecondInsured: {
    id: 'medical-handicapped-placard-use-second-insured',
    questionRef: 'medicalHandicappedPlacardUseSecondInsured',
    title: 'Is the proposed insured currently using a handicapped parking plate/placard/sticker?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCatheterUseSecondInsured: {
    id: 'medical-catheter-use-second-insured',
    questionRef: 'medicalCatheterUseSecondInsured',
    title: 'Is the proposed insured currently using a catheter?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalOxygenEquipmentUseSecondInsured: {
    id: 'medical-oxygen-equipment-use-second-insured',
    questionRef: 'medicalOxygenEquipmentUseSecondInsured',
    title: 'Is the proposed insured currently using oxygen equipment?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalRespiratorUseSecondInsured: {
    id: 'medical-respirator-use-second-insured',
    questionRef: 'medicalRespiratorUseSecondInsured',
    title: 'Is the proposed insured currently using a respirator?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCpapUseSecondInsured: {
    id: 'medical-cpap-use-second-insured',
    questionRef: 'medicalCpapUseSecondInsured',
    title: 'Is the proposed insured currently using CPAP or Bi-PAP?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDefibrillatorUseSecondInsured: {
    id: 'medical-defibrillator-use-second-insured',
    questionRef: 'medicalDefibrillatorUseSecondInsured',
    title: 'Is the proposed insured currently using a defibrillator?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPacemakerUseSecondInsured: {
    id: 'medical-pacemaker-use-second-insured',
    questionRef: 'medicalPacemakerUseSecondInsured',
    title: 'Is the proposed insured currently using a pacemaker?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalDialysisUseSecondInsured: {
    id: 'medical-dialysis-use-second-insured',
    questionRef: 'medicalDialysisUseSecondInsured',
    title: 'Is the proposed insured currently using a dialysis machine?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalUpcomingVisitSecondInsured: {
    id: 'medical-upcoming-visit-second-insured',
    questionRef: 'medicalUpcomingVisitSecondInsured',
    title: 'Does the proposed insured have an upcoming visit with a health care professional?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalCurrentlyPregnantSecondInsured: {
    id: 'medical-currently-pregnant-second-insured',
    questionRef: 'medicalCurrentlyPregnantSecondInsured',
    title: 'Is the proposed insured currently pregnant?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPrimaryCarePhysicianSecondInsuredName: {
    id: 'medical-primary-care-physician-second-insured-name',
    questionRef: 'medicalPrimaryCarePhysicianSecondInsuredName',
    title:
      'List the name of the current or most recent primary care physician for the Second Proposed Insured',
    type: 'text',
    required: true,
  },
  
  medicalPrimaryCarePhysicianSecondInsuredAddress: {
    id: 'medical-primary-care-physician-second-insured-address',
    questionRef: 'medicalPrimaryCarePhysicianSecondInsuredAddress',
    title:
      'List address of current or most recent primary care physician for the Second Proposed Insured',
    type: 'text',
    required: true,
    validationType: 'address',
  },

  medicalMedicationsSecondInsured: {
    id: 'medical-medications-second-insured',
    questionRef: 'medicalMedicationsSecondInsured',
    title: 'List all medications currently being taken.',
    type: 'table',
    required: true,
    minRows: 0,
    maxRows: 3,
    columns: [
      {
        id: 'medicalMedicationsItem',
        title: 'Medication',
        type: 'text',
        required: true,
      },
    ],
  },
};
